// extracted by css-extract-rspack-plugin
module.exports =  {"hris_request_modal":"RequestHRISAccessModal_hris_request_modal__PwJSn","request_sent_message":"RequestHRISAccessModal_request_sent_message__h2AU4"};